import type { ReviewCounts } from "../../shared/model/caseReview";
import { ReviewCounter } from "../../shared/components/review_counts/ReviewCounter";

export interface CaseReviewSubsectionTab { key: string; label: string; counts: ReviewCounts }

interface Props { tabs: CaseReviewSubsectionTab[]; active: string; onSelect: (key: string) => void }

/** Subsection tab strip above the field table. Presentational; the rail shows the same list. */
export function CaseReviewSubsectionTabs({ tabs, active, onSelect }: Props) {
  return <div className="cr-tabs" role="tablist" aria-label="Subsections">
    {tabs.map((tab) => {
      const on = tab.key === active;
      return <button type="button" role="tab" key={tab.key} aria-selected={on} data-on={on} title={tab.label} onClick={() => onSelect(tab.key)}>
        <span className="cr-tab-label">{tab.label}</span>
        <ReviewCounter label={tab.label} counts={tab.counts} />
      </button>;
    })}
  </div>;
}
